/* eslint-disable prefer-const */
import {Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

import { filter } from 'rxjs';

@Directive({
  selector: '[imageCaptions]',
})
export class ImageCaptionDirective implements OnChanges {
  @Input() imageCaptions: any;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private el: ElementRef) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        if (this.imageCaptions) {
          setTimeout(() => {
            this.setCaptions();
          }, 0);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.imageCaptions.currentValue) {
      console.log('set caption');
      this.setCaptions();
    }
  }

  setCaptions() {
    const images = this.el.nativeElement.querySelectorAll('img[data-caption]');
    const parentNode = this.el.nativeElement;
    const verticalCaptionWidth = 160;

    for (const img of images) {
      const imageCaption = img.dataset['caption'];
      const imageCaptionPos = img.dataset['captionPos'] ? img.dataset['captionPos'] : 'bottom';
      console.log(img);

      let imageWrapper: any;
      let imgClone: any;

      imageWrapper = document.createElement('div');
      imgClone = img.cloneNode();
      imageWrapper.appendChild(imgClone);
      imageWrapper.className = 'caption-image-wrapper';
      imageWrapper.classList.add((img.style.float === 'left' || img.style.float === 'right') ? img.style.float : 'none');

      imageWrapper.style.overflow = 'hidden';
      imageWrapper.style.display = 'none';
      imageWrapper.style.cssFloat = (img.style.float === 'left' || img.style.float === 'right') ? img.style.float : 'none';
      imageWrapper.style.width = img.style.width;
      // imageWrapper.style.minWidth = '350px';
      imageWrapper.style.border = [];

      img.style.width = '100%';

      const captionSpan = document.createElement('span');
      captionSpan.style.display = 'flex';
      captionSpan.style.fontSize = '15px';
      captionSpan.style.wordBreak = 'break-word';
      captionSpan.style.lineHeight = '1.7em';
      captionSpan.innerHTML = imageCaption;

      switch (imgClone.style.cssFloat) {
        case 'left':
          imageWrapper.style.margin = '10px 10px 10px 0';
          break;
        case 'right':
          imageWrapper.style.margin = '10px 0 10px 10px';
          break;
        default:
          imageWrapper.style.cssFloat = 'none';
          imageWrapper.style.margin = '10px 0 10px';
          img.style.width = (imageCaptionPos.captionPos === 'left' || imageCaptionPos.captionPos === 'right') ?
            `calc(100% - ${verticalCaptionWidth}px)` : '100%';
          break;
      }

      switch (imageCaptionPos.toString()) {
        case 'bottom':
          captionSpan.style.display = 'block';
          captionSpan.style.padding = '4px 0';
          captionSpan.style.borderBottom = '1px solid #0000002e';

          imgClone.style = null;
          imgClone.style.width = '100%';
          break;
      }

      imageWrapper.appendChild(captionSpan);
      parentNode.appendChild(imageWrapper);
      img.replaceWith(imageWrapper);

      if (img.complete) {
        imageWrapper.style.display = 'block';
      } else {
        img.addEventListener('load', () => {
          imageWrapper.style.display = 'block';
        });
      }
    }
  }
}
